// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LfKP","clinicsSelect":"styles_clinicsSelect__1Oitb"};